import { useMutation, queryCache } from "react-query";
import { request } from "../sites/request";

const options = () => ({
  suspense: false,
  useErrorBoundary: false,
  throwOnError: true,
  onSuccess: () => {
    queryCache.refetchQueries(["etudes"], { force: true });
  },
});

export const useCreateEtude = () => {
  return useMutation((payload) =>
    request({
      url: `etudes`,
      method: "POST",
      body: payload,
    }),
  );
};

export const useDeleteEtude = (etudeId) => {
  return useMutation(
    (etudeId) =>
      request(
        {
          url: `etudes/${etudeId}`,
          method: "DELETE",
        },
        false,
      ),
    options(),
  );
};
